@import "../../../../../globalStyles/commons";

:host {
  display: block;
  height: 100%;
  --calendar-border-color: var(--field-01);
  --scale-size: 3rem;
  --scale-color: var(--layer-accent)
}

.scale {
  width: var(--scale-size);
}

.calendar-month-view {
  display: flex;
  flex-direction: column;
  height: 100%;

  .view-header {
    background: var(--layer-accent-01);
    display: flex;

    .columns {
      display: flex;
      flex: 1;

      .column {
        flex: 1;
        border-inline-start: 1px solid var(--calendar-border-color);

        &:first-child {
          border-inline-start: 0;
        }


        .column-content {
          display: flex;
          align-items: center;
          padding: var(--spacing-04) var(--spacing-05);
          @include font-style(heading-compact-01);
          gap: .5rem;
        }

        .date {
          font-size: 2rem;
          cursor: pointer;
          border-radius: 100%;
          padding: 0.5rem;
        }

        .day {
          font-size: 1rem;
        }
      }
    }

    .scrollbar-placeholder {
      width: var(--scrollbar-width);
    }
  }


  .view-body {
    height: 100%;
    overflow-y: scroll;

    .view-body-scroll {
      display: flex;
      position: relative;
      min-height: 100%;

      .drawing-area {
        flex: 1;

        .multi-day-section {
          border-bottom: 1px solid var(--scale-color);
          min-height: 9rem;

          .multi-day-body-scroll {
            position: relative;
            height: 100%
          }

          .multi-day-background {
            display: flex;
            height: 100%;
            position: absolute;
            width: 100%;

            .columns {
              display: flex;
              flex: 1;

              .column {
                min-height: 9rem;
                flex: 1;
                border-inline-start: 1px solid var(--scale-color);

                .column-header {
                  @include font-style(helper-text-01);
                  padding-inline-start: .5rem;
                  padding-top: .3rem;
                  border-top: .2rem solid transparent;
                }
              }
            }
          }

          .multi-events {
            min-height: 4rem;
            padding-top: 2rem;
            height: 100%;

            .row {
              height: 1.8rem;
              box-sizing: content-box;
              position: relative;
              padding-bottom: .5rem;

              &:last-child {
                padding-bottom: 0;
              }
            }

            .row-spacer {
              height: 1rem;
            }

            .event {
              position: absolute;
              height: 1.8rem;
              text-overflow: ellipsis;
              overflow: hidden;

              .event-title {
                padding: 0.25rem;
                @include font-style(body-01);
              }

              &.clickable {
                cursor: pointer;
              }
            }
          }
        }
      }

      .current-time-line {
        position: absolute;
        z-index: 100;
        pointer-events: none;
        width: calc(100% - var(--scale-size));
        margin-inline-start: var(--scale-size);

        .time {
          position: absolute;
          font-size: .5rem;
          font-weight: 600;
          color: v(--color-primary);
          top: -6px;
          left: -3rem;
          background: v(--color-primary-10);
          padding: 2px;
          border-radius: 3px;
        }

        .dash-line {
          position: absolute;
          left: 0;
          border-bottom: 1px dashed v(--color-primary);
        }

        .dot {
          border-radius: 100%;
          width: 0.5rem;
          height: 0.5rem;
          background: v(--color-primary);
          display: block;
          position: absolute;
          top: -0.25rem;
        }

        .line {
          border-bottom: 2px solid v(--color-primary);
          position: absolute;
          top: -1px;
        }
      }
    }
  }
}

.event {
  background: var(--calendar-event-bg-color);
  border-inline-start: .25rem solid var(--calendar-event-border-color);
  color: v(--color-black);

  &.clickable {
    &:hover {
      color: v(--color-white);
      background: var(--calendar-event-bg-color--hover);
    }
  }
}

.calendar-month-view .view-body .view-body-scroll .drawing-area .multi-day-section .multi-day-background .columns .column {
  &.today {
    background: var(--field-01);

    .column-header {
      border-top-color: v(--color-primary);
    }
  }
}

:host-context([data-theme="dark"]) {
  .event {
    background: var(--calendar-event-dark-bg-color);
    color: v(--color-white);

    &.clickable {
      &:hover {
        color: v(--color-black);
        background: var(--calendar-event-dark-bg-color--hover);
      }
    }
  }
}
